var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.country}},[(_vm.crossBorderProject)?_c('app-icon',{staticClass:"ui-table-cell-country_cross-border-project m-r-4",attrs:{"name":_vm.ICON_NAMES.CROSS_BORDER_PROJECT}}):_vm._e(),_vm._v(_vm._s(_vm.country)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }